(function(){
  var root = document.querySelector('.jshop');
  if(!root) return;
  var grid = root.querySelector('.jshop__grid');

  // Sort dropdown (client-side; Featured = collection order)
  var sortSel = root.querySelector('.jshop__sort');
  if(grid && sortSel){
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.jshop__card'));
    var original = cards.slice();
    sortSel.addEventListener('change', function(){
      var arr = cards.slice(), m = sortSel.value;
      if(m === 'newest'){ arr.sort(function(a,b){ return (+b.dataset.date||0) - (+a.dataset.date||0); }); }
      else if(m === 'price-asc'){ arr.sort(function(a,b){ return (+a.dataset.price||0) - (+b.dataset.price||0); }); }
      else if(m === 'price-desc'){ arr.sort(function(a,b){ return (+b.dataset.price||0) - (+a.dataset.price||0); }); }
      else { arr = original.slice(); }
      arr.forEach(function(c){ grid.appendChild(c); });
    });
  }

  // Hovering a color swatch previews that color on the card image (desktop)
  Array.prototype.forEach.call(root.querySelectorAll('.jshop__card'), function(card){
    var mainImg = card.querySelector('.jshop__img--main');
    if(!mainImg) return;
    var orig = mainImg.getAttribute('src');
    Array.prototype.forEach.call(card.querySelectorAll('.jshop__dot'), function(dot){
      var img = dot.getAttribute('data-img');
      if(!img) return;
      dot.addEventListener('mouseenter', function(){
        mainImg.removeAttribute('srcset');
        mainImg.setAttribute('src', img);
        card.classList.add('is-swatch');
      });
    });
    card.addEventListener('mouseleave', function(){
      mainImg.setAttribute('src', orig);
      card.classList.remove('is-swatch');
    });
  });
})();
